/** ``?blur=1`` on the page: mask people's names and addresses, e.g. while recording a demo video. */
export const recordingBlur = (): boolean => {
  try {
    return new URLSearchParams(window.location.search).has('blur');
  } catch {
    return false;
  }
};

/** ``?consent=1`` on the page: Google shows its consent page even when access was granted before (a demo). */
export const forceConsent = (): boolean => {
  try {
    return new URLSearchParams(window.location.search).has('consent');
  } catch {
    return false;
  }
};

/** bea.lee@example.com → b•••@e•••.com */
export const maskEmail = (email: string): string => {
  const [local = '', domain = ''] = email.split('@');
  const [host = '', ...rest] = domain.split('.');
  const suffix = rest.length ? `.${rest.join('.')}` : '';

  return `${local.slice(0, 1)}•••@${host.slice(0, 1)}•••${suffix}`;
};

/** Bea Lee → B••• L••• */
export const maskName = (name: string): string => name
  .split(/\s+/)
  .filter(Boolean)
  .map((part) => `${part.slice(0, 1)}•••`)
  .join(' ');
